.roleButton {
	all: unset;
	cursor: revert-layer;
	display: inline-flex;
	align-items: center;
	gap: var(--size-3);
	padding-left: 6px;
	border-left: var(--size-border) solid var(--color-border);
	color: var(--color-text-subtle);
	font-size: var(--text-caption);
	font-weight: 500;

	&:hover:not(:disabled) {
		color: var(--color-text);
	}
}

.manageOrgsPopover {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	padding: var(--size-4);
	> ul {
		display: flex;
		flex-direction: column;
		gap: var(--size-3);
		> li {
			display: flex;
			align-items: center;
			gap: var(--size-3);
			font-weight: 600;
		}
	}
}
